<template>
    <v-card :elevation="1" class="background-2 round-card" width="100%">
        <v-card-title class="pa-3 py-1">
            <v-col class="pa-0">
                <p class="pl-2 pl-xl-3 subtitle-2">Configurazione Azioni {{ $trans(modelDef) }}</p>
            </v-col>
            <v-col class="pa-0">
                <v-tabs right hide-slider class="tabs-pill" v-model="tab" background-color="background-2">
                    <v-tab v-if="actionsShow" :key="1" class="secondary-tab">{{ isMobile ? 'Dettagli' : 'Scheda' }}</v-tab>
                    <v-tab v-if="actionsMultiple && !isMobile" :key="2" class="secondary-tab">Multiple</v-tab>
                    <v-tab v-if="actionsTable" :key="3" class="secondary-tab">{{ isMobile ? 'Card' : 'Tabella' }}</v-tab>
                </v-tabs>
            </v-col>
        </v-card-title>
        <v-divider></v-divider>

        <v-tabs-items v-model="tab" touchless dense>
            <v-tab-item v-if="actionsShow" :key="1">
                <actions-show-selector
                    :modelDef="modelDef"
                    :mobile="isMobile"
                    :excludeKeys="isMobile ? excludeKeys : []"
                ></actions-show-selector>
            </v-tab-item>

            <v-tab-item v-if="actionsMultiple && !isMobile" :key="2">
                <actions-multiple-selector
                    :modelDef="modelDef"
                    :mobile="isMobile"
                ></actions-multiple-selector>
            </v-tab-item>

            <v-tab-item v-if="actionsTable" :key="3">
                <actions-table-selector
                    :modelDef="modelDef"
                    :mobile="isMobile"
                ></actions-table-selector>
            </v-tab-item>
        </v-tabs-items>
    </v-card>
</template>

<script>
import ActionsShowSelector from '@/components/common/ActionsShowSelector'
import ActionsTableSelector from '@/components/common/ActionsTableSelector'
import ActionsMultipleSelector from '@/components/common/ActionsMultipleSelector'

export default {
    name: 'ActionsSelector',
    components: {
        ActionsShowSelector,
        ActionsTableSelector,
        ActionsMultipleSelector
    },

    props: {
        modelDef: {
            type: String,
            required: true
        },
        actionsShow: {
            type: Boolean,
            default: true
        },
        actionsMultiple: {
            type: Boolean,
            default: true
        },
        actionsTable: {
            type: Boolean,
            default: true
        },
        // 'desktop' | 'mobile' — propaga :mobile ai sub-selector
        device: {
            type: String,
            default: 'desktop'
        },
        excludeKeys: {
            type: Array,
            default: () => []
        },
    },

    data() {
        return {
            tab: null,
        }
    },

    computed: {
        isMobile() {
            return this.device === 'mobile'
        }
    },

    methods: {

    },

    mounted() {
        this.$store.commit('endProgress')
        // Seleziona il primo tab visibile
        if (!this.actionsShow && this.actionsTable) {
            this.tab = 1
        }
    }
}
</script>

<style scoped>
    .action-container {
        min-height: 100px;
        background-color: rgb(245, 245, 245);
        margin: 12px;
        border-radius: 8px;
        border: 1px solid #ececec;
    }

    .action-card {
        transition: all 0.3s ease;
    }

    .empty-container {
        min-height: 100px;
        background-color: rgb(245, 245, 245);
        border: 1px dashed #ccc;
    }

    .ghost-element {
        background: #BBDEFB !important;
        opacity: 0.5;
    }

    .chosen-element {
        background: #BBDEFB !important;
        opacity: 0.5;
    }

    .drag-handle {
        cursor: move;
    }

    .cursor-pointer {
        cursor: pointer;
    }
</style>
